import React from 'react';
import { motion } from 'framer-motion';
import { PhoneIcon, CalendarCheckIcon, FilterIcon, MessageSquareIcon, PlugIcon, BarChart3Icon } from 'lucide-react';
const features = [{
  icon: PhoneIcon,
  title: '24/7 Call Answering',
  description: 'Never miss important calls, even after hours. Our AI handles calls round the clock with professional greetings.'
}, {
  icon: CalendarCheckIcon,
  title: 'Smart Scheduling',
  description: 'Automatically book appointments by integrating with your calendar. Reduce no-shows with automated reminders.'
}, {
  icon: FilterIcon,
  title: 'Lead Qualification',
  description: 'Identify and qualify potential customers with intelligent questioning. Route hot leads directly to your team.'
}, {
  icon: MessageSquareIcon,
  title: 'Multilingual Support',
  description: 'Communicate with customers in multiple languages. Break down language barriers effortlessly.'
}, {
  icon: PlugIcon,
  title: 'Seamless Integration',
  description: 'Connect with your CRM, calendar, and other business tools. Streamline your workflow without disruption.'
}, {
  icon: BarChart3Icon,
  title: 'Performance Analytics',
  description: 'Gain insights into call patterns, customer interactions, and business opportunities with detailed reports.'
}];
export function Features() {
  return <section id="features" className="py-16 md:py-24 lg:py-32 bg-gradient-to-b from-white to-gray-50" data-id="element-35">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8" data-id="element-36">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12 md:mb-16" data-id="element-37">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-black mb-3 md:mb-4" data-id="element-38">
            Powerful Features
          </h2>
          <p className="text-base md:text-xl text-gray-600 max-w-2xl mx-auto px-4" data-id="element-39">
            Our AI receptionist is equipped with advanced capabilities to handle
            all your communication needs
          </p>
        </motion.div>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8" data-id="element-40">
          {features.map((feature, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1,
          duration: 0.5
        }} whileHover={{
          y: -8
        }} className="relative group" data-id="element-41">
              <div className="h-full bg-white rounded-xl md:rounded-2xl p-6 md:p-8 shadow-lg hover:shadow-2xl transition-all border border-gray-100" data-id="element-42">
                <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-indigo-500 to-sky-500 rounded-t-xl md:rounded-t-2xl" data-id="element-43" />
                <div className="w-12 h-12 md:w-14 md:h-14 bg-gradient-to-br from-indigo-500 to-sky-500 rounded-lg md:rounded-xl flex items-center justify-center mb-4 md:mb-6 group-hover:scale-110 transition-transform" data-id="element-44">
                  <feature.icon size={24} className="text-white md:w-7 md:h-7" data-id="element-45" />
                </div>
                <h3 className="text-lg md:text-xl font-bold text-black mb-2 md:mb-3" data-id="element-46">
                  {feature.title}
                </h3>
                <p className="text-sm md:text-base text-gray-600 leading-relaxed" data-id="element-47">
                  {feature.description}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}